import { render } from "./HeaderComponent.vue?vue&type=template&id=3bd9d8b4&scoped=true&lang=html"
const script = {}

import "./HeaderComponent.vue?vue&type=style&index=0&id=3bd9d8b4&lang=css&scoped=true"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd9d8b4"]])

export default __exports__